export default __webpack_public_path__ + "static/media/modal-icon-api-error.e9d4ca90.svg";